<template>
  <div>
    <p>Once configured:</p>
    <ul>
      <li><strong>Start your endpoints</strong> - Metrics will begin flowing immediately</li>
      <li><strong>Check this capability card</strong> - it will automatically update when metrics are detected</li>
      <li><strong>View the Monitoring tab</strong> to see real-time performance data</li>
    </ul>
    <p>Metrics are sent at regular intervals (default: every 10 seconds), so you should see data appear within a minute.</p>
  </div>
</template>
